import { render, staticRenderFns } from "./OilCollection.vue?vue&type=template&id=168f0819&"
import script from "./OilCollection.vue?vue&type=script&lang=js&"
export * from "./OilCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports